import { render, staticRenderFns } from "./index copy 2.vue?vue&type=template&id=99a88756"
import script from "./index copy 2.vue?vue&type=script&lang=js"
export * from "./index copy 2.vue?vue&type=script&lang=js"
import style0 from "./index copy 2.vue?vue&type=style&index=0&id=99a88756&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99a88756')) {
      api.createRecord('99a88756', component.options)
    } else {
      api.reload('99a88756', component.options)
    }
    module.hot.accept("./index copy 2.vue?vue&type=template&id=99a88756", function () {
      api.rerender('99a88756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/index copy 2.vue"
export default component.exports